import React from 'react';
import { getBrowserLanguage } from 'utils';
import './Loading.scss';

const Loading = () => {
    return (
        <div className='fl-survey-loading' >
            <div>
                <div className='loader' />
                <span className='fl-text-loading'>{getBrowserLanguage() === '日本語' ? '読み込み中' : 'Loading questions'}</span>
            </div>
        </div>
    );
};

export default Loading;
